/* eslint-disable */
import Vue from 'vue';
import Router from 'vue-router';
import VueCookies from 'vue-cookies';
import { Toast } from 'vant';
import axios from 'axios';
import global from '@/api/global';
Vue.use(Toast);
Vue.use(VueCookies);
Vue.use(Router);

const routes = [{
		path: '*',
		redirect: '/home'
	},
	{
		name: 'user',
		component: () =>
			import('./view/user/index.vue'),
		meta: {
			title: '个人中心',
			requireLogin: true // 添加该字段，表示进入这个路由是需要登录的
		}
	},
	{
		name: 'warehousing',
		component: () =>
			import('./view/user/warehousing.vue'),
		meta: {
			title: '更改入库信息'
		}
	},
	{
		name: 'admin_sign',
		component: () =>
			import('./view/activity/admin_sign.vue'),
		meta: {
			title: '签到记录'
		}
	},
	{
		name: 'my_org_list',
		component: () =>
			import('./view/organization/mylist.vue'),
		meta: {
			title: '组织管理',
			requireLogin: true // 添加该字段，表示进入这个路由是需要登录的
		}
	},
	{
		name: 'change_password',
		component: () =>
			import('./view/user/change_password'),
		meta: {
			title: '修改密码',
			requireLogin: true // 添加该字段，表示进入这个路由是需要登录的
		}
	},
	{
		name: 'integration',
		component: () =>
			import('./view/integration/list.vue'),
		meta: {
			title: '正能量值',
			requireLogin: true // 添加该字段，表示进入这个路由是需要登录的
		}
	},
	{
		name: 'serviceHour',
		component: () =>
			import('./view/serviceHour/list.vue'),
		meta: {
			title: '服务时数',
			requireLogin: true // 添加该字段，表示进入这个路由是需要登录的
		}
	},
	{
		name: 'team',
		component: () =>
			import('./view/home/team'),
		meta: {
			title: '团队介绍'
		}
	},
	{
		name: 'image_update',
		component: () =>
			import('./view/user/image_update'),
		meta: {
			title: '修改头像',
			requireLogin: true // 添加该字段，表示进入这个路由是需要登录的
		}
	},
	{
		name: 'setting',
		component: () =>
			import('./view/user/setting'),
		meta: {
			title: '设置',
			requireLogin: true // 添加该字段，表示进入这个路由是需要登录的
		}
	},
	{
		name: 'home',
		component: () =>
			import('./view/home'),
		meta: {
			title: '首页'
		}
	},
	{
		name: 'news_list',
		component: () =>
			import('./view/article/list'),
		meta: {
			title: '新闻列表',
			keepAlive: true
		}
	},
	{
		name: 'news_details',
		component: () =>
			import('./view/article/details'),
		meta: {
			title: '新闻详情'
		}
	},
	{
		name: 'volunteer_register',
		component: () =>
			import('./view/home/volunteer_register'),
		meta: {
			title: '志愿者注册'
		}
	},
	{
		name: 'organization_register',
		component: () =>
			import('./view/organization/organization_register'),
		meta: {
			title: '组织注册',
			requireLogin: true // 添加该字段，表示进入这个路由是需要登录的
		}
	},
	{
		name: 'organization_edit',
		component: () =>
			import('./view/organization/organization_edit'),
		meta: {
			title: '组织编辑',
			requireLogin: true // 添加该字段，表示进入这个路由是需要登录的
		}
	},
	{
		name: 'organization_attend',
		component: () =>
			import('./view/organization/attendList'),
		meta: {
			title: '我的组织',
			requireLogin: true // 添加该字段，表示进入这个路由是需要登录的
		}
	},
	{
		name: 'organization_list',
		component: () =>
			import('./view/organization/list'),
		meta: {
			title: '加入组织'
		}
	},
	{
		name: 'organization_details',
		component: () =>
			import('./view/organization/details'),
		meta: {
			title: '组织详情'
		}
	},
	{
		name: 'admin_list',
		component: () =>
			import('./view/organization/admin_list'),
		meta: {
			title: '组织信息',
			requireLogin: true // 添加该字段，表示进入这个路由是需要登录的
		}
	},
	{
		name: 'examine_org_list',
		component: () =>
			import('./view/organization/examine_org_list'),
		meta: {
			title: '组织审核',
			requireLogin: true // 添加该字段，表示进入这个路由是需要登录的
		}
	},
	{
		name: 'examine_org_details',
		component: () =>
			import('./view/organization/examine_org_details'),
		meta: {
			title: '审核详情',
			requireLogin: true // 添加该字段，表示进入这个路由是需要登录的
		}
	},
	{
		name: 'regProtocol',
		component: () =>
			import('./view/home/regProtocol'),
		meta: {
			title: '用户协议',
		}
	},
	{
		name: 'login',
		component: () =>
			import('./view/login/login'),
		meta: {
			title: '登录',
		}
	},
	{
		name: 'forget',
		component: () =>
			import('./view/login/forget'),
		meta: {
			title: '找回密码',
		}
	},
	{
		name: 'message',
		component: () =>
			import('./view/user/message'),
		meta: {
			title: '我的消息',
			requireLogin: true // 添加该字段，表示进入这个路由是需要登录的
		}
	},
	{
		name: 'help',
		component: () =>
			import('./view/home/help'),
		meta: {
			title: '帮助中心',
		}
	},
	{
		name: 'base',
		component: () =>
			import('./view/user/base'),
		meta: {
			title: '基本信息',
			requireLogin: true // 添加该字段，表示进入这个路由是需要登录的
		}
	},
	{
		name: 'user_info',
		component: () =>
			import('./view/user/user_info'),
		meta: {
			title: '用户信息',
			requireLogin: true // 添加该字段，表示进入这个路由是需要登录的
		}
	},
	{
		name: 'activity_list',
		component: () =>
			import('./view/activity/list'),
		meta: {
			title: '活动招募',
		}
	},
	{
		name: 'attend_list',
		component: () =>
			import('./view/activity/attend_list'),
		meta: {
			title: '我的参与',
			requireLogin: true // 添加该字段，表示进入这个路由是需要登录的
		}
	},
	{
		name: 'activity_edit',
		component: () =>
			import('./view/activity/activity_edit'),
		meta: {
			title: '活动编辑',
			requireLogin: true // 添加该字段，表示进入这个路由是需要登录的
		}
	},
	{
		name: 'my_act_list',
		component: () =>
			import('./view/activity/my_act_list'),
		meta: {
			title: '项目管理',
			requireLogin: true // 添加该字段，表示进入这个路由是需要登录的
		}
	},
	{
		name: 'examine_activity',
		component: () =>
			import('./view/activity/examine_activity'),
		meta: {
			title: '活动审核',
			requireLogin: true // 添加该字段，表示进入这个路由是需要登录的
		}
	},
	{
		name: 'activity_add',
		component: () =>
			import('./view/activity/add'),
		meta: {
			title: '发布活动',
			requireLogin: true // 添加该字段，表示进入这个路由是需要登录的
		}
	},
	{
		name: 'activity_details',
		component: () =>
			import('./view/activity/details'),
		meta: {
			title: '活动详情'
		}
	},
	{
		name: 'admin_act_details',
		component: () =>
			import('./view/activity/admin_details'),
		meta: {
			title: '活动管理',
			requireLogin: true // 添加该字段，表示进入这个路由是需要登录的
		}
	},
	{
		name: 'activity_menber',
		component: () =>
			import('./view/activity/activity_menber'),
		meta: {
			title: '活动成员',
			requireLogin: true // 添加该字段，表示进入这个路由是需要登录的
		}
	},
	{
		name: 'activity_settlement',
		component: () =>
			import('./view/activity/activity_settlement'),
		meta: {
			title: '项目结算',
			requireLogin: true // 添加该字段，表示进入这个路由是需要登录的
		}
	},
	{
		name: 'integration_rank',
		component: () =>
			import('./view/integration/ranking'),
		meta: {
			title: '正能量榜'
		}
	},
	{
		name: 'serviceHour_rank',
		component: () =>
			import('./view/serviceHour/ranking'),
		meta: {
			title: '服务时数榜'
		}
	},
	{
		name: 'smhx_ysmh',
		component: () => import('./view/smhx_ysmh/index'),
		meta: {
			title: '云上缅怀'
		}
	}
];

// add route path
routes.forEach(route => {
	route.path = route.path || '/' + (route.name || '');
});

const router = new Router({
	routes
});
/*const router = new Router({//去掉#
	routes:routes,
	mode:'history'
});*/
router.beforeEach((to, from, next) => {
	const title = to.meta && to.meta.title;
	const $cookies = require('vue-cookies');
	var count = router.options.routes.length;
	console.log('auth_token=' + $cookies.get("auth_token"));
	console.log('cookies=' + $cookies);
	if(title) {
		document.title = title;
	}
	if(to.meta.requireLogin) { // 判断该路由是否需要登录权限
		axios({ //查看token是否过期
			method: 'post',
			url: global.baseURL + 'appsite/phoneUser/userInfo',
			params: {
				"auth_token": $cookies.get("auth_token")
			}
		}).then((resp) => {
			console.log(resp)
			if(resp.data.status == 0) {
				Toast('请先登录');
				next({
					path: '/login'
				})
			}
		}).catch(resp => {
			console.log('请求失败：' + resp);
			Toast('请先登录');
			next({
				path: '/login'
			})
		});
		if($cookies.get("auth_token") != null) { // 获取本地的token是否存在
			next();
		} else { //如果token不存在则重新登录
			Toast('请先登录');
			next({
				path: '/login'
			})
		}
	} else {
		next();
	}
});

export {
	router
};
